<template>
  <div v-if="show" class="card speed_test">
    <div class="speed_test__header">
      <h4 class="title">
        {{ translate('speed_test') }}
      </h4>
    </div>
    <div class="speed_test__content">

      <form autocomplete="off" class="speed_test__form" v-if="!begin_test">
        <div class="interfaces">
          <label> {{ translate('speed.interfaces') }} </label>
          <sis-select
            v-model="options.ifaces"
            :options="sim_list"
            :searchable="false"
            :show-labels="false"
            :close_on_select="true"
            :clear-on-select="false"
            :hide_selected="true"
            :multiple="true"
          />
        </div>

        <div class="params">
          <label> {{ translate('speed.params') }} </label>
          <sis-select
            v-model="options.mode"
            :options="[{'label':'download', 'id':'iperf_down'}, {'label':'upload', 'id':'iperf_up'}, {'label':'ping ', 'id':'ping'}]"
            :searchable="false"
            :show-labels="false"
            :close_on_select="true"
            :clear-on-select="false"
            :hide_selected="true"
            :multiple="true"
          />
        </div>

        <div class="speed_test__form-row">
          <div class="speed_test__form-row__input">
            <fg-input
              v-model="options.threads"
              type="number"
              :label="translate('speed.threads')"
              :placeholder="translate('speed.threads')"
            />
          </div>
          <div class="speed_test__form-row__input">
            <fg-input
              v-model="options.duration"
              type="number"
              :label="translate('speed.duration')"
              :placeholder="translate('speed.duration')"
            />
          </div>
          <div class="speed_test__form-row__input">
            <fg-input
              v-model="options.server"
              type="text"
              :label="translate('speed.server')"
              :placeholder="translate('speed.server')"
              @focusout="check_ip()"
            />
          </div>
        </div>
        <div class="speed_test__waiting_time">
          <label>{{translate('speed.max_result_waiting_time')}}: {{ estimated_waiting_time }}</label>
        </div>
      </form>

      <div class="speed_test__result" v-else>
        <scale-loader v-if="loading"/>
        <div v-else class="response_table4 text-center">
          <div v-if="error" class="content text-center title"> {{ translate('self_tests.test_error') }} </div>
          <table v-else>
            <thead>
              <tr>
                <th rowspan="1" class="traffic_block">
                  {{ translate('parameters') }} / {{ translate('self_tests.ifaces') }}
                </th>
                <th v-for="(item,key) in th" :key="key" class="traffic_block">
                  {{ item.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item2,key2) in tr" :key="key2">
                <td class="tdFont traffic_block">
                  {{ translate("self_tests." + item2.name2) }}
                </td>
                <td v-for="(val,dkey) in ifaces" :key="dkey">
                  {{ result_data[val][item2.name2][0] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="speed_test__waiting_time" v-if="loading">
          <label>{{translate('speed.result_waiting_time')}}: {{ this.time_conversion(this.test_duration) }}</label>
        </div>
      </div>

      <div class="speed_test__button">
        <button
          v-if="!begin_test"
          type="submit"
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="start_test"
          :disabled="
          options.ifaces.length < 1 ||
          options.mode.length < 1 ||
          +options.duration < 1 ||
          +options.threads < 1 ||
          options.server === ''
          "
        >
        {{ translate('speed.start_test') }}
        </button>
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['fid', 'sim_list'],

  data () {
    return {
      begin_test: true,
      loading: true,
      show: true,
      error: false,
      server_default: this.$store.getters.getSelfTestServers,
      options: {
        ifaces: ['stcp'],
        mode: ['iperf_down','iperf_up','ping'],
        threads: 16,
        duration: 20,
        server: this.$store.getters.getSelfTestServers
      },
      th: [],
      tr: [],
      ifaces: [],
      result_data: [],
      test_duration: '',
      interval: 0
    }
  },
  mounted () {
    this.checkIsselftestrunning()
  },
  deactivated(){
    clearInterval(this.interval)
  },

  computed:{
    estimated_waiting_time(){
      let duration = this.options.duration
      let iperf = this.options.mode
      let ifaces = this.options.ifaces
      let sum  = duration * iperf.length * ifaces.length * 3.5
      if (iperf.indexOf('ping') >= 0){
        sum += 5 * ifaces.length
      }
      return this.time_conversion(sum)
    }
  },

  methods: {
    check_ip(){
      let arrIp = this.options.server.split(".");
      if (arrIp.length !== 4) {
        this.global_notify('danger', 'Invalid IP')
        this.options.server = ''
        return false
      }
      for (let oct of arrIp) {
        if ( isNaN(oct) || Number(oct) < 0 || Number(oct) > 255){
          this.global_notify('danger', 'Invalid IP')
          this.options.server = ''
          return false
        }
      }
      return true
    },
    countdown(){
      if (this.test_duration > 0) {
        this.test_duration -= 1
      }else{
        this.test_duration = 0
      }
    },
    time_conversion(time){
      let hours = Math.round(Math.floor(time / 60 / 60));
      let minutes = Math.round(Math.floor(time / 60) - (hours * 60));
      let seconds = Math.round(time % 60);
      if (hours < 1) {
        return ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
      }
      return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
    },
    cancel () {
      this.begin_test = false
      this.$emit('close')
      clearInterval(this.interval)
      clearInterval(this.wait_interval)
    },

    checkIsselftestrunning () {
      this.$http.v1.statusDeviceTestSelfTest(this.fid, {dev_id: this.fid},(response) => {
        if (response.data.selftest_id === undefined) {
          this.begin_test = false
          this.loading = false
        }else{
          let selfTestId = response.data.selftest_id

          let time = Math.floor(Date.now()/1000);
          this.test_duration = response.data.test_duration - (time - response.data.start_ts)
          this.wait_interval = setInterval(() => {
            this.countdown()
          }, this.$store.getters.getCountdown)

          this.interval = setInterval(() => {
            this.selftest(selfTestId)
          }, this.$store.getters.getDeviceSelftestResult)
        }
      })
    },
    start_test(){
      if (!this.check_ip()) return false
      this.begin_test = true
      this.loading = true
      let options = this.options
      options.duration = Number(this.options.duration)
      options.threads = Number(this.options.threads)

      this.$http.v1.initDeviceTestSelfTest(this.fid, {"comm":"selftest_init", params: options}, (response) => {
        let selfTestId = response.data.selftest_id

        this.test_duration = response.data.test_duration
        this.wait_interval = setInterval(() => {
          this.countdown()
        }, this.$store.getters.getCountdown)

        this.interval = setInterval(() => {
          this.selftest(selfTestId)
        }, this.$store.getters.getDeviceSelftestResult)
      })
    },
    selftest(selfTestId){
      this.$http.v1.getDeviceTestSelfTestsResult({selftest_id: selfTestId}, (response) => {
        let th = []
        let tr = []
        this.result_data = response.data.result
        if (response.data.state === 0) {
          console.log("Queue")
        } else if (response.data.state === 1) {
          console.log("Sent to device")
        } else if (response.data.state === 2) {
          console.log("Performed")
        } else if (response.data.state === 5) {
          this.loading = false
          this.error = true
          clearInterval(this.interval)

        } else if (response.data.state === 6) {
          this.loading = false
          clearInterval(this.interval)

          let name_iface = Object.keys(response.data.result)
          for (let i in name_iface) {
            th.push({name: name_iface[i]})
          }
          this.ifaces = name_iface
          this.th = th

          let parameters = Object.keys(response.data.result[name_iface[0]])
          for (let i in parameters) {
            tr.push({name2: parameters[i]})
          }
          this.parameters = parameters
          this.tr = tr
        }
      })
    }
  }
}

</script>

<style lang='scss' scoped>
  .marginButton {
    margin: 5px;
  }
  .v-spinner {
    margin-bottom: 10px;
  }
  .tdFont {
    font-weight: bold;
  }
  .response_table4{
    height: auto;
  }
  .speed_test{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
      }
    }
    &__content{
      padding: 10px;
    }
    &__form{
      &-row{
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__input{
          width: 32%;
        }
      }
    }
    &__result{
      margin-bottom: 20px;
      table{
        display: table;
        height: auto;
        margin: auto;
      }
    }
    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
      }
    }
    &__waiting_time{
      label{
        text-align: center;
      }
    }
  }
  @media (max-width:600px) {
    .speed_test{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
